import { render, staticRenderFns } from "./ModulesSet.vue?vue&type=template&id=8de9ec1c&scoped=true"
import script from "./ModulesSet.vue?vue&type=script&lang=ts"
export * from "./ModulesSet.vue?vue&type=script&lang=ts"
import style0 from "./ModulesSet.vue?vue&type=style&index=0&id=8de9ec1c&prod&lang=less"
import style1 from "./ModulesSet.vue?vue&type=style&index=1&id=8de9ec1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de9ec1c",
  null
  
)

export default component.exports